module.exports = __webpack_public_path__ + "static/media/2017_conf_The_Product_Formula.65ebd005.png";